function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 15.1826C12.0869 15.1826 15.4707 11.7915 15.4707 7.71191C15.4707 3.625 12.0796 0.241211 7.99268 0.241211C3.91309 0.241211 0.529297 3.625 0.529297 7.71191C0.529297 11.7915 3.92041 15.1826 8 15.1826ZM5.61963 5.83691C5.95654 5.83691 6.17627 6.06396 6.17627 6.43018V7.72656L6.06641 8.90576L7.15771 7.74121L9.91895 4.97266C10.0288 4.86279 10.1753 4.79688 10.3584 4.79688C10.688 4.79688 10.915 5.0166 10.915 5.36084C10.915 5.50732 10.8418 5.66113 10.7319 5.771L7.95605 8.53223L6.77686 9.63818L7.89746 9.521H9.25977C9.62598 9.521 9.86035 9.74072 9.86035 10.0703C9.86035 10.4072 9.6333 10.627 9.27441 10.627H5.7002C5.31201 10.627 5.06299 10.4512 5.06299 10.0044V6.44482C5.06299 6.08594 5.29004 5.83691 5.61963 5.83691Z",
  fill: "#878793"
});

function SvgIconArrowRightBottomFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightBottomFilled);
export default __webpack_public_path__ + "static/media/icon-arrow-right-bottom-filled.6f33ec10.svg";
export { ForwardRef as ReactComponent };